// src/langFetchPatch.js
import i18n from "./i18n";

(function patchGlobalFetch() {
  const API_BASES = [
    "/api",
    "https://api-testenv.ananassolutions.ca",
    "https://api.ananassolutions.ca",
  ];

  const isApiUrl = (input) => {
    const url = typeof input === "string" ? input : input?.url || "";
    return API_BASES.some((base) => url.startsWith(base));
  };

  const addLangHeader = (existingHeaders) => {
    const headers = new Headers(existingHeaders || {});
    const lang = (i18n?.language || navigator.language || "fr")
      .slice(0, 2)
      .toLowerCase();
    headers.set("X-Locale", lang);
    return headers;
  };

  const origFetch = window.fetch;

  window.fetch = async (input, init = {}) => {
    if (!isApiUrl(input)) return origFetch(input, init);

    // Cas 1: input = URL string (ton cas)
    if (typeof input === "string") {
      const headers = addLangHeader(init.headers);
      return origFetch(input, { ...init, headers });
    }

    // Cas 2: input = Request
    // On recrée la Request en gardant method/body/credentials etc., mais
    // avec nos headers fusionnés.
    const mergedHeaders = addLangHeader(init.headers || input.headers);
    const req = new Request(input, { ...init, headers: mergedHeaders });
    return origFetch(req);
  };
})();
